module.exports = "data:image/jpeg;base64,77u/bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvdHJpcC41Y2RiYmJiYy5qcGciOw=="